export default {
  title: 'Mine dokumenter',
  description: 'Dine uploadede virksomhedsdokumenter. Du kan til enhver tid downloade eller erstatte dem.',
  document_types: {
    owner_document: 'Ejerens legitimation',
    business_document: 'Virksomhedsdokument',
  },
  kinds: {
    vat_registration: 'Momsregistrering',
    trade_registration: 'Erhvervsregistrering',
    trade_license: 'Erhvervstilladelse',
    commercial_register_extract: 'Uddrag fra handelsregisteret',
    financial_statements: 'Regnskab',
    other: 'Andet',
    passport: 'Pas',
    driver_license: 'Kørekort',
    id_card: 'ID-kort',
    residence_permit: 'Opholdstilladelse',
  },
  sides: {
    front: 'Forside',
    back: 'Bagside',
  },
  fields: {
    document: 'Dokument',
    kind: 'Art',
    side: 'Side',
    uploaded_at: 'Uploadet',
    expires_at: 'Udløber',
    retained_until: 'Opbevares til',
    deleted_at: 'Slettet',
    storage_deleted_at: 'Permanent slettet',
    actions: 'Handlinger',
  },
  values: {
    no_file_name: '—',
    version: 'v{{version}}',
  },
  filters: {
    type_placeholder: 'Filtrer efter dokumenttype',
    kind_placeholder: 'Filtrer efter art',
  },
  retention: {
    deletable: 'Kan slettes',
    tooltip:
      'Tysk lovgivning (GoBD / §147 AO) kræver, at vi opbevarer dette dokument indtil {{date}}. Det kan først slettes efter denne dato.',
    tooltip_no_date: 'Dette dokument er omfattet af en lovpligtig opbevaringsperiode og kan endnu ikke slettes.',
  },
  buttons: {
    download: 'Download',
    download_front: 'Download forside',
    download_back: 'Download bagside',
    reupload: 'Upload igen',
    delete: 'Slet',
  },
  empty: 'Du har endnu ikke uploadet nogen dokumenter.',
  delete_modal: {
    title: 'Slet dokument',
    description:
      'Vælg, hvordan dette dokument skal slettes. »Slet« arkiverer det og skjuler det på din liste. »Slet permanent« sletter filerne for altid og er kun muligt, når den lovpligtige opbevaringsperiode er udløbet.',
    delete: 'Slet',
    permanently_delete: 'Slet permanent',
    cancel: 'Annuller',
    retention_alert:
      'Disse dokumenter er omfattet af lovpligtige opbevaringsperioder i henhold til tysk lovgivning (GoBD / §147 AO). Permanent sletning af et dokument fjerner dets filer uigenkaldeligt.',
  },
  reupload_modal: {
    title: 'Upload dokument igen',
    description: 'Upload en ny version af dette dokument. Den tidligere version bliver erstattet.',
    type: {
      label: 'Dokumenttype',
      placeholder: 'Vælg dokumenttype',
    },
    kind: {
      label: 'Dokumentart',
      placeholder: 'Vælg dokumentart',
    },
    front: {
      label: 'Dokumentets forside',
    },
    back: {
      label: 'Dokumentets bagside (valgfri for nogle dokumenter)',
    },
    expires_at: {
      label: 'Dokumentets udløbsdato',
      placeholder: 'Vælg udløbsdato',
    },
    buttons: {
      select_file: 'Vælg fil',
      submit: 'Upload',
      cancel: 'Annuller',
    },
  },
  toasts: {
    download_error: 'Dokumentet kunne ikke downloades.',
    delete_success: 'Dokumentet er slettet.',
    delete_error: 'Dokumentet kunne ikke slettes.',
    reupload_success: 'Dokumentet er uploadet.',
    reupload_error: 'Dokumentet kunne ikke uploades.',
  },
};
